/**
 * PlaceholderPage – on-brand "coming soon" for sections not yet implemented.
 * Used by renderPageContent in App.js for unknown activePage values (e.g. Reports, Partners).
 */
import React from 'react';
import { ArrowLeft, Clock } from 'lucide-react';
import { IconTile, Button } from '../components/ui/index.tsx';

export interface PlaceholderPageProps {
  title: React.ReactNode;
  setActivePage?: (page: string) => void;
}

const PlaceholderPage = ({ title, setActivePage }: PlaceholderPageProps) => (
  <div className="flex flex-col items-center justify-center min-h-[60vh]">
    <div className="text-center max-w-md p-10 bg-white/80 backdrop-blur-xl rounded-2xl shadow-lg shadow-slate-200/60 border border-slate-200/70">
      <div className="flex justify-center mb-5">
        <IconTile icon={Clock} tone="brand" variant="solid" size="lg" />
      </div>
      <h1 className="text-3xl font-bold text-gray-900 mb-2">{title}</h1>
      <p className="text-slate-500 mb-8">This area is coming soon — we&apos;re building it now.</p>
      {setActivePage && (
        <Button variant="secondary" icon={ArrowLeft} onClick={() => setActivePage('Dashboard')}>
          Back to Dashboard
        </Button>
      )}
    </div>
  </div>
);

export default PlaceholderPage;
